import { render, staticRenderFns } from "./SinPermisosView.vue?vue&type=template&id=bb0b647e&scoped=true"
import script from "./SinPermisosView.vue?vue&type=script&lang=js"
export * from "./SinPermisosView.vue?vue&type=script&lang=js"
import style0 from "./SinPermisosView.vue?vue&type=style&index=0&id=bb0b647e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0b647e",
  null
  
)

export default component.exports